/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import {analyticsResponsesGet, AnalyticsResponsesGetParams} from "../fn/analytics/analytics-responses-get";
import {QuestionnaireResponseSummaryModel} from "../models/questionnaire-response-summary-model";
import {
    analyticsResponseAnswersGet,
    AnalyticsResponseAnswersGetParams
} from "../fn/analytics/analytics-response-answers-get";
import {QuestionnaireResponseAnswerModel} from "../models/questionnaire-response-answer-model";
import {
    accountAnalyticsSummaryGet,
    AccountAnalyticsSummaryGetParams
} from "../fn/analytics/account-analytics-summary-get";
import {AccountAnalyticsSummaryModel} from "../models/account-analytics-summary-model";
import {
    analyticsResponsesSummaryGet,
    AnalyticsResponsesSummaryGetParams
} from "../fn/analytics/analytics-responses-summary-get";
import {QuestionnaireResponsesSummaryModel} from "../models/questionnaire-responses-summary-model";
import {
    analyticsInsightsAndTrendsGet,
    AnalyticsInsightsAndTrendsGetParams
} from "../fn/analytics/analytics-insights-and-trends-get";
import {InsightsAndTrendsModel} from "../models/insights-and-trends-model";
import {PaginatedList} from "../models/paginator/paginated-list";

@Injectable({ providedIn: 'root' })
export class AnalyticsService extends BaseService {
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http);
    }

    /** Path part for operation `authenticatePost()` */
    static readonly analyticsResponsesPath = '/api/v1/identity/authenticate';

    /**
     * Gets all responses for a singular questionnaire
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `analyticsResponsesGetJson()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    analyticsResponsesGetJson$Response(params: AnalyticsResponsesGetParams, headers: HttpHeaders,  context?: HttpContext): Observable<StrictHttpResponse<PaginatedList<QuestionnaireResponseSummaryModel>>> {
        return analyticsResponsesGet(this.http, this.rootUrl, params, headers, context);
    }

    /**
     * Gets all responses for a singular questionnaire
     *
     *
     *
     * This method provides access only to the response body.
     * To access the full response (for headers, for example), `analyticsResponsesGetJson$Response()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    analyticsResponsesGetJson(params: AnalyticsResponsesGetParams, headers: HttpHeaders, context?: HttpContext): Observable<PaginatedList<QuestionnaireResponseSummaryModel>> {
        return this.analyticsResponsesGetJson$Response(params, headers, context).pipe(
            map((r: StrictHttpResponse<PaginatedList<QuestionnaireResponseSummaryModel>>): PaginatedList<QuestionnaireResponseSummaryModel> => r.body)
        );
    }

    /**
     * Get responses summary model for questionnaire
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `analyticsResponsesSummaryGetJson()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    analyticsResponsesSummaryGetJson$Response(params: AnalyticsResponsesSummaryGetParams, headers: HttpHeaders,  context?: HttpContext): Observable<StrictHttpResponse<QuestionnaireResponsesSummaryModel>> {
        return analyticsResponsesSummaryGet(this.http, this.rootUrl, params, headers, context);
    }

    /**
     * Get responses summary model for questionnaire
     *
     *
     *
     * This method provides access only to the response body.
     * To access the full response (for headers, for example), `analyticsResponsesSummaryGetJson$Response()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    analyticsResponsesSummaryGetJson(params: AnalyticsResponsesSummaryGetParams, headers: HttpHeaders, context?: HttpContext): Observable<QuestionnaireResponsesSummaryModel> {
        return this.analyticsResponsesSummaryGetJson$Response(params, headers, context).pipe(
            map((r: StrictHttpResponse<QuestionnaireResponsesSummaryModel>): QuestionnaireResponsesSummaryModel => r.body)
        );
    }

    /**
     * Gets all answers for a singular questionnaire response (instance)
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `analyticsResponseAnswersGetJson()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    analyticsResponseAnswersGetJson$Response(params: AnalyticsResponseAnswersGetParams, headers: HttpHeaders,  context?: HttpContext): Observable<StrictHttpResponse<QuestionnaireResponseAnswerModel[]>> {
        return analyticsResponseAnswersGet(this.http, this.rootUrl, params, headers, context);
    }

    /**
     * Gets all answers for a singular questionnaire response (instance)
     *
     *
     *
     * This method provides access only to the response body.
     * To access the full response (for headers, for example), `analyticsResponseAnswersGetJson$Response()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    analyticsResponseAnswersGetJson(params: AnalyticsResponseAnswersGetParams, headers: HttpHeaders, context?: HttpContext): Observable<QuestionnaireResponseAnswerModel[]> {
        return this.analyticsResponseAnswersGetJson$Response(params, headers, context).pipe(
            map((r: StrictHttpResponse<QuestionnaireResponseAnswerModel[]>): QuestionnaireResponseAnswerModel[] => r.body)
        );
    }

    /**
     * Get analytics summary for a particular account
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `accountAnalyticsSummaryGetJson()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    accountAnalyticsSummaryGetJson$Response(params: AccountAnalyticsSummaryGetParams, headers: HttpHeaders,  context?: HttpContext): Observable<StrictHttpResponse<AccountAnalyticsSummaryModel>> {
        return accountAnalyticsSummaryGet(this.http, this.rootUrl, params, headers, context);
    }

    /**
     * Get analytics summary for a particular account
     *
     *
     *
     * This method provides access only to the response body.
     * To access the full response (for headers, for example), `accountAnalyticsSummaryGetJson$Response()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    accountAnalyticsSummaryGetJson(params: AccountAnalyticsSummaryGetParams, headers: HttpHeaders, context?: HttpContext): Observable<AccountAnalyticsSummaryModel> {
        return this.accountAnalyticsSummaryGetJson$Response(params, headers, context).pipe(
            map((r: StrictHttpResponse<AccountAnalyticsSummaryModel>): AccountAnalyticsSummaryModel => r.body)
        );
    }

    /**
     * Get insights and trends model for questionnaire
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `questionnaireInsightsAndTrendsGet()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    questionnaireInsightsAndTrendsGet$Response(params: AnalyticsInsightsAndTrendsGetParams, headers: HttpHeaders,  context?: HttpContext): Observable<StrictHttpResponse<InsightsAndTrendsModel>> {
        return analyticsInsightsAndTrendsGet(this.http, this.rootUrl, params, headers, context);
    }

    /**
     * Get insights and trends model for questionnaire
     *
     *
     *
     * This method provides access only to the response body.
     * To access the full response (for headers, for example), `questionnaireInsightsAndTrendsGet$Response()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    questionnaireInsightsAndTrendsGet(params: AnalyticsInsightsAndTrendsGetParams, headers: HttpHeaders, context?: HttpContext): Observable<InsightsAndTrendsModel> {
        return this.questionnaireInsightsAndTrendsGet$Response(params, headers, context).pipe(
            map((r: StrictHttpResponse<InsightsAndTrendsModel>): InsightsAndTrendsModel => r.body)
        );
    }
}
